module.exports = __webpack_public_path__ + "static/img/52.e3fa247.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/52.png
// module id = zbyL
// module chunks = 1